export const selectAuthState = (state) => state.auth || {};
export const selectAuthUid = (state) => state.auth?.uid || '';
export const selectAuthEmail = (state) => state.auth?.email || '';
export const selectIsAuthLoading = (state) => state.auth?.isLoading ?? true;
export const selectIsLoggedIn = (state) => !!state.auth?.uid;
